<template>
  <button
    class="button"
    :class="hollow ? 'hollow' : ''"
    @click="$emit('click')"
  ><slot></slot></button>
</template>

<script>
export default {
	name: "Button",

	components: {
	},

	props:      {
	  hollow: {
	    type: Boolean,
      default: false
    }
	},
	methods:    {
		onEscapeKeyUp( event ) {
			if ( event.key === "Escape" ) this.$emit( "close" );
		}
	},
};
</script>

<style scoped>
  .button {
  }

  .button {
    outline: none;
    border: 1px solid #007BC1;
    background-color: #007BC1;
    color: #FFFFFF;
    fill: #FFFFFF;
    text-transform: uppercase;
    border-radius: 0.2em;
    font-size: inherit;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5em 1em;
    -webkit-transition: all .5s ease 0s;
    transition: all .5s ease 0s;
    cursor: pointer;
    font-weight: 500;
  }

  .button:hover {
    background-color: #0C97E7;
  }

  .button.hollow {
    border-width: 2px;
    background-color: #FFFFFF;
    color: #007BC1;
  }
  .button.hollow:hover {
    background-color: #D6EEFF;
  }
</style>
